import { Component, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { delay } from 'rxjs/operators';
import { DesignService } from 'src/app/service/design.service';
import { OrderService } from 'src/app/service/order.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { TreeNodeService } from 'src/app/shared/services/treedata.service';
import { ApiService } from '../../service/api.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  designs: any = [];
  singles: any;
  couples: any;
  coupleinfos = {};
  nodeinfos = {};
  filtered_singles: any;
  filtered_couples: any;
  downloadURL: any;
  uid: any;
  constructor(private storage: AngularFireStorage, private profileService: ProfileService, private designService: DesignService, private router: Router, private ApiService: ApiService, private treeService: TreeNodeService, private orderService: OrderService) { }

  userInfo: any = { firstName: null, lastname: null }

  orders
  orderStatusInfo
  displayedColumns: string[] = ['date', 'number', 'total', 'status'];
  orderLength;
  design: string = ''
  gedcoms: any = [];
  gedcomsLength
  news
  avatar_url: string = './assets/image/profile.svg';

  totalCols = 10
  profileCols = 2
  profileRows = 7
  orderCols = 6
  orderRows = 4
  newsCols = 2
  newsRows = 7
  otherCols = 2
  otherRows = 3
  blankCols = 0
  blankRows = 0

  goToOrder(order) {
    this.router.navigateByUrl('/dashboard/orders', { state: order });
  }

  goToDesign(design, id) {
    this.designService.goToDesign(design, id)
  }


  
  getOrder() {
    this.orderService.getOrders().then((resp) => {
      let orders: any = []
      let ordersDoc = []
      orders = resp
      orders.forEach((order: any) => {
        order.articles = [];
        order.displayDetails = false;
        this.orderService.getOrderArticles(order.id).then((resp) => {
          let articles: any = []
          articles = resp
          this.orderService.getOrderArticlesAttributes(order.id).then((resp) => {
            let attributes: any = []
            attributes = resp
            articles.forEach(article => {
              article.attributes = [];
              attributes.forEach(attribute => {
                if(article.order_article_id == attribute.order_article_id){
                  article.attributes.push(attribute);
                }
              });
              order.articles.push(article)
            });
            order.totalPrice = parseFloat(order.product_price)* order.articles[0].quantity + parseFloat(order.shipping_price) + parseFloat(order.VAT);
          })
        });
      });
      
      this.orders = orders.sort((a, b) => (new Date(b.created_date).getTime() - new Date(a.created_date).getTime())).slice(0, 5);
      this.orderLength = this.orders.length
    }, err => console.log(err))

  }

  ngOnInit(): void {
    
    this.getOrder()

    localStorage.removeItem('doc_id');
    localStorage.removeItem('background')
    this.ApiService.getGedcoms().then((gedcoms: any) => {
      gedcoms.forEach(gedcom => {
        this.gedcoms.push({ filename: gedcom.filename.split('-')[1].split('.')[0], uploaded: gedcom.uploaded })
      });
      this.gedcoms.sort((a: any, b: any) => {
        return <any>new Date(b.uploaded) - <any>new Date(a.uploaded);
      });
    }, err => { console.log(err) })
    this.designService.getDesigns().subscribe((designs: any) => {
      this.designs = []
      designs.forEach((doc, index) => {
        this.designs.push({ id: doc.payload.doc.id, data: doc.payload.doc.data() })
      });
      this.designs.sort((a: any, b: any) => {
        return <any>new Date(b.data.saved * 1000) - <any>new Date(a.data.saved * 1000);
      });
    }, err => console.log(err))
    if (window.innerWidth <= 768) {
      this.totalCols = 9
      this.profileCols = 9
      this.profileRows = 5
      this.orderCols = 9
      this.orderRows = 4
      this.newsCols = 9
      this.newsRows = 7
      this.otherCols = 9
      this.otherRows = 3
      this.blankCols = 0
      this.blankRows = 4
    }
    this.orderStatusInfo = [
      { status: 'Processing', btnLabel: 'Make changes', color: '#B6C1B1' },
      { status: 'Confirmed', btnLabel: 'Under production', color: '#D7D4CB' },
      { status: 'Shipped', btnLabel: 'Delivery Confirmation', color: '#B6C1B1' },
      { status: 'Delivered', btnLabel: 'Write a review', color: '#B6C1B1' },
    ]
    this.profileService.getUserProfile().subscribe((profile: any) => {

      const ref = this.storage.ref(`profiles/${profile.payload.data().uid}`);
      this.downloadURL = ref.getDownloadURL().subscribe((res) => {
        this.avatar_url = res;
      })
      this.userInfo = {
        firstName: profile.payload.data().firstName,
        lastName: profile.payload.data().lastName,
        email: profile.payload.data().email
      }
    }, err => {
      console.log(err)
    })


    this.getOrder()
    this.news = [
      { image: './assets/image/dashboard/news1.jpg', title: 'We have released a new size', date: 'Feb 1, 2021, 8:00pm', description: 'Now you can order a Beautiful poster in size AC.' },
      { image: './assets/image/dashboard/news2.jpg', title: 'We have released a new size', date: 'Feb 1, 2021, 8:00pm', description: 'Now you can order a Beautiful poster in size AC.' },
      { image: './assets/image/dashboard/news1.jpg', title: 'We have released a new size', date: 'Feb 1, 2021, 8:00pm', description: 'Now you can order a Beautiful poster in size AC.' }
    ]
  }

  onResize(event) {
    if (event.target.innerWidth > 768) {
      this.totalCols = 10
      this.profileCols = 2
      this.profileRows = 7
      this.orderCols = 6
      this.orderRows = 4
      this.newsCols = 2
      this.newsRows = 7
      this.otherCols = 2
      this.otherRows = 3
      this.blankCols = 0
      this.blankRows = 0
    }
    else if (event.target.innerWidth <= 768) {
      this.totalCols = 9
      this.profileCols = 9
      this.profileRows = 5
      this.orderCols = 9
      this.orderRows = 4
      this.newsCols = 9
      this.newsRows = 7
      this.otherCols = 9
      this.otherRows = 3
      this.blankCols = 0
      this.blankRows = 4
    }
  }

}
